import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";

export const fetchActiveCountries = async () => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}localization/country/active/`);
    const result = response.data;
    if (result.response_code === 1 && Array.isArray(result.data)) {
      return result.data.map(country => ({ label: country.name, value: country.id }));
    } else {
      console.error('Fetched countries are not valid:', result);
      return [];
    }
  } catch (error) {
    console.error('Error fetching countries:', error);
    return [];
  }
};

export const fetchActiveCountryCode = async () => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}localization/country/active/`);
    const result = response.data;
    if (result.response_code === 1 && Array.isArray(result.data)) {
      return result.data.map(country => ({ label: country.country_code, value: country.id }));
    } else {
      console.error('Fetched countries are not valid:', result);
      return [];
    }
  } catch (error) {
    console.error('Error fetching countries:', error);
    return [];
  }
};

export const fetchActiveLanguages = async () => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}localization/languages/active/`);
    const result = response.data;
    if (result.response_code === 1 && Array.isArray(result.data)) {
      return result.data.map(language => ({ label: language.name, value: language.id }));
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

export const fetchTimezone = async () => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}localization/timezones/`);
    const result = response.data;
    if (result.response_code === 1 && Array.isArray(result.data)) {
      return result.data.map(tz => ({
        label: `${tz.name} (${tz.timezone})`,
        value: tz.id
      }));
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};